module.exports = __webpack_public_path__ + "static/media/caret-circle-down.42dd29d3.svg";